import { Fragment } from "react/jsx-runtime";
import CoverImgCard from "../Components/CoverImgGroup/CoverImgCard/CoverImgCard";
import SelfUploadBlock from "../Components/SelfUploadBlock/SelfUploadBlock";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
interface ISelfCoverGroupProps {
  handleUploadBlockBtnClick: () => void;
  handleChoseImgChange: (state: boolean, id: number, media_id?: string) => void;
  data: any[];
  handleDeleteItem: (id: number, media_id?: string) => void;
  collection: any[];
  emitChange: (newItems) => void;
  handleLookBtnClick?: (id: string) => void;
}

const SelfCoverGroup: React.FC<ISelfCoverGroupProps> = (props) => {
  const {
    handleUploadBlockBtnClick,
    data,
    collection,
    handleChoseImgChange,
    handleDeleteItem,
    emitChange,
    handleLookBtnClick
  } = props;
  // 拖拽结束时的回调函数
  const onDragEnd = (result) => {
    const { source, destination } = result;
    // 如果没有拖拽到有效区域，直接返回
    if (!destination) return;
    // 重新排序
    const newItems = Array.from(data);
    const [removed] = newItems.splice(source.index, 1);
    newItems.splice(destination.index, 0, removed);
    emitChange(newItems);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-1">
        {(provided, snapshot) => (
          <div
            className="cover-img-group-wrapper"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <SelfUploadBlock
              onClick={() => {
                handleUploadBlockBtnClick();
              }}
              style={{ marginBottom: 15, marginLeft: 18, width: 126, height: 160 }}
            />
            {data?.length > 0 && data.map((item, index) => (
              <Draggable key={String(item.id)} draggableId={String(item.id)} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <CoverImgCard
                      showLookBtn={true}
                      handleDeleteBtnClick={() => {
                        handleDeleteItem(item.id, item.media_id)
                      }}
                      name={item.name}
                      img={item.play_info.cover_url}
                      isChecked={
                        (collection || []).findIndex((step) => (step?.id === item?.id || step?.material?.media_id === item?.media_id) ) >
                        -1
                      }
                      handleCheckStateChange={(e) => {
                        handleChoseImgChange(e, item.id, item.media_id);
                      }}
                      handleLookBtnClick={() => {
                        handleLookBtnClick(item.media_id);
                      }}
                      id={item.id}
                    />
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SelfCoverGroup;
